const BASE_FORM_SERVICE = {
  'bulletinId': 'Código de boletin',
  'type': 'tipo de sistema de vehiculo',
  'model': 'Modelo',
  'katashiki': 'Katashiki',
  'subject': 'Asunto',
  'symptom': 'Sintoma',
  'cause': 'Causa',
  'fix': 'Fix',
  'countermeasure': 'Contramedida',
  'production': 'Producción',
  'partsInfo': 'Información de Partes',
  'petition': 'Petición',
};

const BASE_FORM_TMC = {
  'bulletinId': 'Código de boletin',
  'type': 'tipo de sistema de vehiculo',
  'model': 'Modelo',
  'katashiki': 'Katashiki',
  'subject': 'Asunto',
};

export const errorFields = (type) => {
  if (type === 'TMC') {
    return BASE_FORM_TMC;
  }
  return BASE_FORM_SERVICE;
};
